import { QuestionType } from "../enums";
import { QuestionSpecification } from '../client-questions';

export class QuestionView {
  id: number;
  text: string;
  infoTitle: string;
  infoDescription: string;
  type: QuestionType;
  specification: QuestionSpecification;
  questionOption: QuestionOptionView[];

  constructor(values: any) {
    values.questionOption = values.questionOption.map(x => new QuestionOptionView(x));
    Object.assign(this, values)
  }
}


export class QuestionOptionView {
  id: number;
  questionId: number;
  text: string;
  dependentOptionIds: number[];
  requiredOptionIds: number[];

  constructor(values: any) {
    Object.assign(this, values)
  }
}
